import { Header } from 'components/molecules';
import { CreateRoleTemplate } from 'components/templates';
import { withAuth } from 'HOCs';

const breadcrumbs = [{ label: 'Administración' }];

const CreateRolePage = () => {
  return (
    <>
      <Header
        title="Roles"
        subtitle="Crea un rol"
        breadCrumbsProps={{ breadcrumbs: breadcrumbs }}
      />
      <CreateRoleTemplate />
    </>
  );
};

export default withAuth(CreateRolePage);
